// extracted by mini-css-extract-plugin
module.exports = {"container":"CartDropdown_container__i3qyI","cartItems":"CartDropdown_cartItems__PMgSf","loading":"CartDropdown_loading__wVsUn"};